import React, { useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

class ExportPdf extends React.Component {
  constructor() {
    super();
    this.state = {
      openDialog: false,
      proceedWithAddress: false,
    };
  }

  handleClickOpen = () => {
    debugger
    if (this.props.showPopUp && this.props.showPopUp !== "undefined") {
      this.setState({ openDialog: true });
    } else {
      this.exportPDF(this.props.exportData);
    }
  };

  handleClose = async (proceed) => {
    debugger
    this.setState(
      { openDialog: false, proceedWithAddress: proceed },
      async () => {
        debugger;
        if (proceed) {
          try {
            // Check if summaryWithAddressExport is a function
            if (typeof this.props.summaryWithAddressExport === "function") {
              const exportDataArray =
                await this.props.summaryWithAddressExport();

              // Update exportData
              this.props.setExportData(exportDataArray);

              // Generate PDF after setting export data
              this.exportPDF(exportDataArray);
            } else {
              console.error("summaryWithAddressExport is not a function");
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        } else {
          const exportDataArray = await this.props.summaryExport(
            this.props.items
          );

          // Update exportData
          this.props.setExportData(exportDataArray);
          // Proceed without addresses
          this.exportPDF(exportDataArray);
        }
      }
    );
  };

      exportPDF = (data) => {
    debugger
    const { proceedWithAddress } = this.state;

    if (false) {
      // Remove "Address" from labelHeader
      let updatedLabelHeader = this.props.labelHeader.filter(
        (item) => item !== "Address"
        // &&
        //   item !== "Start Address" &&
        //   item !== "End Address"
      );

      // Adjust exportData: remove col8 and rename col9 to col8
      let updatedExportData = this.props.exportData.map((item) => {
        debugger;
        if (false) {
          // Destructure col5 and col8, and spread the rest of the properties
          const { col5, col8, ...rest } = item;

          // Return the updated item with shifted columns
          return {
            ...rest,
            col5: rest.col6,
            col6: rest.col7,
            col7: rest.col9,
            col8: rest.col10,
            col9: rest.col11,
            col10: rest.col12,
          };
        } else {
          // Destructure col7, col8, col9, and spread the rest of the properties
          const { col7, col8, col9, ...rest } = item;

          // Conditionally update col7 and col8 based on chooseReport
          const updatedCol7 =
            this.props.chooseReport === "movement" ? col8 : col7;
          const updatedCol8 =
            this.props.chooseReport === "movement" ? col8 : col9;
          // this.props.chooseReport ==  "movement" ? col7: col8 : col8: col9
          // Return the updated item
          return {
            ...rest,
            col7: updatedCol7,
            col8: updatedCol8,
          };
        }
      });

      // Generate PDF with updated data
      this.generatePDF(
        updatedLabelHeader,
        updatedExportData.sort((a, b) => a.col1 - b.col1)
      );
    } else {
      // Generate PDF with original data
      this.generatePDF(
        this.props.labelHeader,
        data?.sort((a, b) => a.col1 - b.col1)
      );
    }
  };

  generatePDF = (filterHeaders, filterData) => {
    debugger
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3, or A4
    const orientation = "landscape"; // portrait or landscape

    const doc = new jsPDF("l", "mm", [297, 241]);
    doc.setFontSize(15);

    const title = `${this.props.title}`;
    const reportGeneatedDate = `Report Generated At :- ${moment(new Date()).format(
      "DD-MM-YYYY hh:mm A"
    )}`;

   let headers = [];
    if (this.props.type === "report") {
      let header = [];
      filterHeaders.forEach((element) => {
        header.push(element.name);
      });
      headers.push(header);
    } else {
      headers = [filterHeaders];
    }
    let data = [];
    if (this.props.type === "report") {
      filterData.forEach((el, index) => {
        let dataKey = [];
        filterHeaders.forEach((element) => {
          dataKey.push(el[element.keyName]);
        });
        data.push(dataKey);
      });
    } else {
      data = filterData.map((elt, index) => [
        elt.col1,
        elt.col2,
        elt.col3,
        elt.col4,
        elt.col5,
        elt.col6,
        elt.col7,
        elt.col8,
        elt.col9,
        elt.col10,
        elt.col11,
        elt.col12,
        elt.col13,
        elt.col14,
        elt.col15,
        elt.col16,
      ]);
    }

    let content = {
      startY: 30,
      head: headers,
      body: data,
      styles: { fontSize: "8" },
    };
    doc.text(title, 15, 17);
    doc.text(reportGeneatedDate, 15, 25);
    doc.setFontSize(10);
 

    doc.autoTable(content);
    doc.save(
      `${this.props.reportName}(${moment(new Date()).format(
        "DD-MM-YYYYThh:mm:ss A"
      )}).pdf`
    );
  };

  render() {

    return (
      <div>
        <div
          id={this.props.id ? this.props.id : "exportPdfButton"}
          onClick={this.handleClickOpen}
        >
          <PictureAsPdfIcon />
        </div>
        <Dialog
          open={this.state.openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Export PDF"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              "Include the address in the PDF ?
              <br /> It might take more time.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleClose(false)}
              color="primary"
              variant="outlined"
            >
              No
            </Button>
            <Button
              onClick={() => this.handleClose(true)}
              color="primary"
              autoFocus
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ExportPdf;
